import { render } from "./SearchSummaryCollection.vue?vue&type=template&id=733bed72&scoped=true"
import script from "./SearchSummaryCollection.vue?vue&type=script&lang=js"
export * from "./SearchSummaryCollection.vue?vue&type=script&lang=js"

import "./SearchSummaryCollection.vue?vue&type=style&index=0&id=733bed72&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-733bed72"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QItem});
